export default __webpack_public_path__ + "static/media/SeñaleroDerecho.bc9201bf.jpg";